import { type StrapiLocale } from '@nuxtjs/strapi/dist/runtime/types'
import { type Article_Plain } from '@webamboos/admin'

export function useArticles() {
  const { localeProperties } = useI18n()
  const { find } = useStrapi()

  const fetch = async () => {
    const { data } = await find('articles', {
      locale: localeProperties.value.code as StrapiLocale,
      populate: {
        image: true,
        category: {
          populate: {
            icon: true,
          },
        },
      },
      sort: 'publishedAt:desc',
    })

    const articles = data as unknown as Article_Plain[]
    if (!articles) throw showError({ statusCode: 500 })
    const [first, ...rest] = articles

    return {
      first,
      rest,
    }
  }

  const fetchBySlug = async (slug: string) => {
    const { data } = await find('articles', {
      locale: localeProperties.value.code as StrapiLocale,
      populate: {
        image: true,
        authors: {
          populate: {
            image: true,
          },
        },
        category: {
          populate: {
            icon: true,
          },
        },
      },
      filters: {
        slug,
      },
    })

    const [article] = data as unknown as Article_Plain[]
    return article
  }

  return {
    fetch,
    fetchBySlug,
  }
}
